import { FaPlug, FaSmile, FaCalendarAlt, FaMapMarkedAlt } from 'react-icons/fa';

const counter = [
  {
    id: 1,
    icon: <FaPlug />, // Plug icon
    title: 'Connections',
    count: '20000',
  },
  {
    id: 2,
    icon: <FaSmile />, // Smile icon
    title: 'Happy Customers',
    count: '15000',
  },
  {
    id: 3,
    icon: <FaCalendarAlt />, // Calendar icon
    title: 'Years in Service',
    count: '10',
  },
  {
    id: 4,
    icon: <FaMapMarkedAlt />, // Map Marker icon
    title: 'Service Areas',
    count: '50',
  },
];

export default counter;